import "./Pricing.css";
import { useNavgate, useNavigate } from "react-router-dom";
import ads from "../../../assets/images/adsCS.png";
import { backdropClasses } from "@mui/material";

const PricingCards = () => {
  const navigate = useNavigate();

  const ComingSoon = () => {
    navigate("/ComingSoon");
  };

  return (
    <>
      <div className="cards-section">
        {/* <div className="pricing-card">
        <h3>MEDIUM</h3>
        <span className="membership">Membership</span>
        <div className="price">
          <span>$</span>05.00
        </div>
        <div className="divider" />
        <p className="impressions">1000 impression</p>
        <button onClick={ComingSoon}>GET STARTED</button>
      </div>

      <div className="pricing-card premium">
        <h3>PREMIUM</h3>
        <span className="membership">Membership</span>
        <div className="price dark">
          <span>$</span>15.00
        </div>
        <div className="divider dark" />
        <p className="impressions dark">1000 impression</p>
        <button className="dark" onClick={ComingSoon}>
          GET STARTED
        </button>
      </div>

      <div className="pricing-card">
        <h3>STANDARD</h3>
        <span className="membership">Membership</span>
        <div className="price">
          <span>$</span>08.50
        </div>
        <div className="divider" />
        <p className="impressions">1000 impression</p>
        <button onClick={ComingSoon}>GET STARTED</button>
      </div>
*/}
        <div className="ads-coming-soon">
          <img src={ads} alt="Ads Coming Soon" width={"70%"} />
        </div>
      </div>
      <hr style={{ borderColor: "#48464B" }} />
    </>
  );
};

export default PricingCards;
